import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    acceptCampaignAndGroupSelectorData,
    acceptCampaignAndGroupSelectorDataDna,
    fetchCampaignAndGroupSelectorCampaignsData,
    fetchCampaignAndGroupSelectorGroupsData,
    selectCampaignAndGroupSelectorCampaign,
    selectCampaignAndGroupSelectorGroup
} from '../../actions/campaignAndGroupSelector';
import {
    CampaignAndGroupSelector,
    CampaignAndGroupSelectorProps
} from '../../components/CampaignAndGroupSelector/CampaignAndGroupSelector';
import { SelectorItems } from '../../components/CampaignAndGroupSelector/Selector/Selector';
import { getAccessRightsForCampaignAndGroupSelector } from '../../service/CampaignAndGroupSelectorHelpers';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

interface OwnProps {
    onCancel: () => void;
}

type StateProps = TStateProps<CampaignAndGroupSelectorProps>;

type DispatchProps = TDispatchProps<CampaignAndGroupSelectorProps, OwnProps>;

const mapStateToProps = (state: State): StateProps => {
    const {
        grid: {
            campaignAndGroupSelector: {
                campaignItems,
                campaignSelected,
                selectorStatus,
                groupSelected,
                groupItems,
                entityToSelectType: type
            }
        },
        commonData: { operatorFeatures, accessRights }
    } = state;

    const {
        canAddInDna,
        canAddInDnaOnly,
        fullyAvailable
    } = getAccessRightsForCampaignAndGroupSelector(
        operatorFeatures,
        accessRights,
        type,
        campaignSelected
    );

    return {
        campaignItems,
        campaignSelected,
        selectorStatus,
        groupItems,
        groupSelected,
        type,
        canAddInDna,
        canAddInDnaOnly,
        fullyAvailable
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    return {
        onAccept: (): void => {
            dispatch(acceptCampaignAndGroupSelectorData());
            ownProps.onCancel();
        },
        onAcceptDna: (): void => {
            dispatch(acceptCampaignAndGroupSelectorDataDna());
            ownProps.onCancel();
        },
        onCampaignSelect: (selectorItems: SelectorItems): void => {
            dispatch(selectCampaignAndGroupSelectorCampaign(selectorItems));
        },
        onCampaignInputChange: (filter: string): void => {
            dispatch(fetchCampaignAndGroupSelectorCampaignsData(filter));
        },
        onGroupInputChange: (filter: string): void => {
            dispatch(fetchCampaignAndGroupSelectorGroupsData(filter));
        },
        onGroupSelect: (selectorItems: SelectorItems): void => {
            dispatch(selectCampaignAndGroupSelectorGroup(selectorItems));
        }
    };
};

export const CampaignAndGroupSelectorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(CampaignAndGroupSelector);
